module.exports = __webpack_public_path__ + "img/main.b174a4e7.jpg";